import * as React from "react"
import styled from "styled-components"
import H3 from "../atoms/typography/H3"

interface Props {
  title: string
  icon: React.ReactNode
  selected: boolean
  onClick: () => void
  disabled?: boolean
}

const ButtonContainer = styled.div<{ selected: boolean; disabled?: boolean }>`
  cursor: ${(props) => (props.disabled ? undefined : "pointer")};
  width: 200px;
  height: 182px;
  border-radius: ${(props) => props.theme.borders.softRadius};
  box-shadow: 0px 0px 10px rgba(119, 119, 119, 0.25);
  padding: ${(props) => props.theme.spacings.large};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-content: center;
  background-color: ${(props) =>
    props.disabled
      ? props.theme.colors.greyLighter
      : props.selected
        ? props.theme.colors.greyLight
        : props.theme.colors.white};
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};

  :hover {
    ${(props) => (props.disabled ? undefined : "filter: brightness(80%)")};
  }
`

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
`

const StatisticSelectionChipButton: React.FunctionComponent<Props> = ({ title, icon, selected, onClick, disabled }) => {
  return (
    <ButtonContainer selected={selected} onClick={onClick} disabled={disabled}>
      <H3 textAlign="center">{title}</H3>
      <IconContainer>{icon}</IconContainer>
    </ButtonContainer>
  )
}

export default StatisticSelectionChipButton
